import {
  effect,
  inject,
  Injectable,
  PLATFORM_ID,
  signal,
  WritableSignal,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Loader global BLOQUEANTE. Un único `<app-processing-overlay>` montado en el root
 * lee `visible()` y `message()`; cualquier flujo largo e irreversible (p. ej. la
 * confirmación del pago con tarjeta) invoca `show()`/`hide()` sin preocuparse de
 * cubrir el header/menú ni de bloquear el scroll.
 *
 * Bloquea el scroll del body mientras está visible, mismo patrón que
 * `CartDrawerService`.
 */
@Injectable({ providedIn: 'root' })
export class BlockingLoaderService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  readonly visible: WritableSignal<boolean> = signal(false);
  readonly message: WritableSignal<string | null> = signal(null);

  constructor() {
    effect(() => {
      if (!this.isBrowser) return;
      document.body.style.overflow = this.visible() ? 'hidden' : '';
    });
  }

  /** Muestra el overlay bloqueante. `message` opcional sobrescribe el copy por defecto. */
  show(message?: string): void {
    this.message.set(message ?? null);
    this.visible.set(true);
  }

  hide(): void {
    this.visible.set(false);
  }
}
